import { AdminCompanyResponse } from 'src/api/services/CompanyClient';
import { Api } from 'src/api';
import { authQueries } from 'src/api/queries/queries';
import { defaultOptions, UseQueryOptionsObject } from '../queries.utils';
import { useMakeQuery } from '../useMakeQuery';

const useCompanyQuery = (
  companyId: string,
  options?: UseQueryOptionsObject<AdminCompanyResponse>,
) => {
  return useMakeQuery<AdminCompanyResponse>(
    [authQueries.company, companyId],
    () => Api.company.fetchCompany(companyId),
    {
      staleTime: 60 * 1000,
      ...defaultOptions({
        auth: true,
        ...(options ?? {}),
      }),
    },
  );
};

export { useCompanyQuery };
